<template>
    <div class="panel panel-default">
        <div class="panel-body" style="padding: 0">
            <div class="text-center">
                <div style="padding: 20px 0">
                    <h3>
                        {{ company.data.name }}
                    </h3>

                    <div class="text-muted">
                        CVR: {{ company.data.cvr }} <span
                        v-if="company.data.ean">&middot; EAN: {{ company.data.ean }}</span>
                    </div>

                    <div v-if="company.data.website">
                        <a :href="company.data.website">
                            {{ company.data.website }}
                        </a>
                    </div>

                    <div>
                        <template v-for="tag in company.data.tags">
                            <span class="label" :style="{'background-color': tag.color}">
                                {{ tag.name }}
                            </span>&nbsp;
                        </template>
                    </div>
                </div>
            </div>

            <div v-if="company.data.industry || company.data.number_of_employees || company.data.established_at"
                 class="text-center"
                 style="padding: 10px 6px; border-top: 1px solid #eeeeee"
            >
                <div v-if="company.data.industry">
                    <i class="fa fa-industry"></i> {{ company.data.industry }}
                </div>

                <div v-if="company.data.number_of_employees">
                    <i class="fa fa-users"></i> {{ company.data.number_of_employees }}
                </div>

                <div v-if="company.data.established_at">
                    <i class="fa fa-star-of-life"></i> {{ company.data.established_at | date }}
                </div>
            </div>

            <div class="text-center" style="padding: 10px 0; background-color: #eeeeee">
                <span v-if="company.data.email">
                    <i class="fa fa-envelope"></i> <a :href="'mailto:' + company.data.email">{{
                        company.data.email
                    }}</a>
                </span>

                <span v-if="company.data.email && company.data.phone">
                    &middot;
                </span>

                <span v-if="company.data.phone">
                    <i class="fa fa-phone"></i> {{ company.data.phone }}
                </span>
            </div>

            <div class="text-center" style="padding: 10px 0">
                {{ company.data.address.street_address }}<br>
                {{ company.data.address.zip_code }} {{ company.data.address.city }}<br>
                {{ company.data.address.verbose_country }}
            </div>

            <div v-if="portals.length" class="text-center" style="padding: 10px 0; background-color: #eeeeee">
                <span v-for="(portal, index) in portals">
                    <span v-if="portal.pivot.path">
                        <a :href="portal.base_url + '/' + portal.pivot.path">
                            {{ portal.name }}
                        </a>
                    </span>

                    <span v-else-if="portal.pivot.external_id">
                        <a :href="portal.base_url + '/node/' + portal.pivot.external_id">
                            {{ portal.name }}
                        </a>
                    </span>

                    <span v-else>
                        {{ portal.name }}
                    </span>
                    
                    <span v-if="index !== portals.length - 1">
                        &middot;
                    </span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Avatar from '../../../../../../../components/Avatar'

export default {
    components: {Avatar},
    props: ['company'],

    computed: {
        portals() {
            return this.company.data.portals
        }
    }
}
</script>
